import RootState from '@vue-storefront/core/types/RootState'
import config from 'config'
import { Module } from 'vuex'
import { CategoryService } from '@vue-storefront/core/data-resolver'
import { DataResolver } from 'core/data-resolver/types/DataResolver'

export const module: Module<any, RootState> = {
  namespaced: true,
  state: {
    homePageArtists: [],
    popularVenues: [],
    popularCities: [],
    popularGenres: []
  },
  mutations: {
    'SET_HOME_PAGE_ARTISTS' (state, homePageArtists) {
      state.homePageArtists = homePageArtists
    },
    'SET_POPULAR_VENUES' (state, popularVenues) {
      state.popularVenues = popularVenues
    },
    'SET_POPULAR_CITIES' (state, popularCities) {
      state.popularCities = popularCities
    },
    'SET_POPULAR_GENRES' (state, popularGenres) {
      state.popularGenres = popularGenres
    }
  },
  getters: {
    getHomePageArtists: (state) => state.homePageArtists,
    getPopularVenues: (state) => state.popularVenues,
    getPopularCities: (state) => state.popularCities,
    getPopularGenres: (state) => state.popularGenres
  },
  actions: {
    async loadPopularVenues ({ commit, dispatch, getters }) {
      const entityType = 'venue'

      if (getters.getPopularVenues.length === 0) {
        const result = await dispatch('loadPopularEntities', { entityType })

        if (result) {
          commit('SET_POPULAR_VENUES', result)
        }
      }
    },
    async loadPopularCities ({ commit, dispatch, getters }) {
      const entityType = 'city'

      if (getters.getPopularCities.length === 0) {
        const result = await dispatch('loadPopularEntities', { entityType })

        if (result) {
          commit('SET_POPULAR_CITIES', result)
        }
      }
    },
    async loadPopularGenres ({ commit, dispatch, getters }) {
      const entityType = 'genre'

      if (getters.getPopularCities.length === 0) {
        const result = await dispatch('loadPopularEntities', { entityType })

        if (result) {
          commit('SET_POPULAR_GENRES', result)
        }
      }
    },
    async loadPopularEntities (_, { entityType }) {
      const categorySearchOptions: DataResolver.CategorySearchOptions = {
        sort: 'frontend_position:asc',
        size: config.popular.entityCount ? config.popular.entityCount : 12,
        filters: {
          entity_type: entityType
        }
      }

      return CategoryService.getCategories(categorySearchOptions)
    },
    async loadHomePageArtists ({ commit }) {
      const categorySearchOptions: DataResolver.CategorySearchOptions = {
        size: 1,
        filters: {
          url_path: config.popular.homePageArtistCategory
        }
      }

      const result = await CategoryService.getCategories(categorySearchOptions)
      const allCategory = result[0]

      if (allCategory && allCategory.popular_artists) {
        commit('SET_HOME_PAGE_ARTISTS', JSON.parse(allCategory.popular_artists))
      }
    }
  }
}
